
import { MapLocation } from '@/types/location';

// Real Life Gym Locations
export const realLifeGyms: MapLocation[] = [
  {
    id: 7001,
    name: "Real Life Gym - Riyadh (Al Narjis)",
    type: "Gym",
    devices: 4,
    coordinates: [24.829252861728776, 46.68263407301188],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
